import { BlobPoint } from './BlobPoint';
import { Blob } from './Blob';
import { Point } from '../../utils/Point';
import { TweenMax } from 'gsap/TweenMax';

export class BlobRing {
	public parent: Blob;
	public radius: number;
	private points: Array<BlobPoint> = [];
	private color: string;

	constructor(basePoints: Array<Point>, parent: Blob) {
		this.parent = parent;

		for (let i = 0; i < basePoints.length; i++) {
			this.points.push(new BlobPoint(basePoints[i], this));
		}
	}

	public setColor(color: string, speed) {
		TweenMax.to(this, speed, { color: color });
	}

	public render(time: number, radius: number) {
		this.radius = radius;

		let p0 = this.points[this.points.length - 1].getPosition(time);
		let p1 = this.points[0].getPosition(time);
		let _p2 = p1;

		this.parent.context.beginPath();
		this.parent.context.globalAlpha = 0.5;
		this.parent.context.fillStyle = this.color;

		// this.parent.context.arc(this.parent.centerPoint.x, this.parent.centerPoint.y, this.radius, 0, 2 * Math.PI);

		this.parent.context.moveTo((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);

		let xc, yc, p2;
		for (let i = 1; i < this.points.length; i++) {
			p2 = this.points[i].getPosition(time);
			xc = (p1.x + p2.x) / 2;
			yc = (p1.y + p2.y) / 2;
			this.parent.context.quadraticCurveTo(p1.x, p1.y, xc, yc);
			p1 = p2;
		}

		xc = (p1.x + _p2.x) / 2;
		yc = (p1.y + _p2.y) / 2;
		this.parent.context.quadraticCurveTo(p1.x, p1.y, xc, yc);
		this.parent.context.fill();
	}
}
